import React, { useState } from "react";
import Helmet from "react-helmet";
import { Layout, Button, Tooltip, Drawer } from "antd";
const { Header, Sider, Content, Footer } = Layout;
import { LogoutOutlined, UserOutlined, MenuOutlined } from "@ant-design/icons";
import Nav from "./nav";
import DataSource from "./data-source";
import QuickSearch from "./quick-search";
import AnnoucementBar from "./announcement-bar";
import { withUser } from "@unifiedpatents/sso";
import { useMediaQuery } from "react-responsive";

const styles = {
  fullscreen: {
    width: "100%",
    minHeight: "100%",
    margin: 0
  },
  content: {
    overflow: "initial",
    width: "100%"
  },
  header: {
    background: "#fff",
    padding: "0 12px"
  },
  sider: {
    overflowY: "auto"
  },
  drawer: {
    padding: 0
  },
  menuButton: {
    marginRight: 16
  },
  userButton: {
    float: "right",
    marginTop: 12
  },
  footer: {
    textAlign: "center"
  },
  footerLink: {
    padding: "0 8px"
  }
};

const BaseContainer = ({ user, children }) => {
  const { status, action } = user;
  const [navDrawerVisible, setNavDrawerVisible] = useState(false);
  const _showNavDrawer = () => setNavDrawerVisible(true);
  const _hideNavDrawer = () => setNavDrawerVisible(false);
  const isDesktopOrLaptop = useMediaQuery({
    query: '(min-width: 1224px)'
  })
  const reportedUrl = window.location.href;
  const subjectPrefix = "Correction needed for page";
  let zendeskLink = `https://support.unifiedpatents.com/hc/en-us/requests/new?subject=${encodeURIComponent(subjectPrefix)}+${encodeURIComponent(reportedUrl)}`;
  return (
    (<Layout style={styles.fullscreen}>
      {!status.isLoggedIn && <AnnoucementBar text="Sign Up To Receive Daily Updates" link="https://eepurl.com/gi_JPz?utm_source=Portal&utm_campaign=ad-banner&utm_medium=site" />}
      <Helmet titleTemplate="%s | Unified Patents" />
      <Layout>
        {isDesktopOrLaptop ? (
          <Sider style={styles.sider}>
            <Nav />
          </Sider>
        ) : (
          <Drawer placement="left" closable={false} open={navDrawerVisible} onClose={_hideNavDrawer} bodyStyle={styles.drawer}>
            <Nav onMenuItemClick={_hideNavDrawer} />
          </Drawer>
        )}
        <Layout>
          <Header style={styles.header}>
            {isDesktopOrLaptop ? null : <Button size="large" icon={<MenuOutlined />} aria-label="Toggle Side Menu" onClick={_showNavDrawer} style={styles.menuButton} />}
            <QuickSearch style={{ width: isDesktopOrLaptop ? 450 : 200 }} />
            <Tooltip title={status.isLoggedIn ? "Logout" : "Login / Sign Up"} placement="bottomRight">
              <Button
                size="large"
                icon={status.isLoggedIn ? <LogoutOutlined /> : <UserOutlined />}
                aria-label={status.isLoggedIn ? "Log Out" : "Log In / Sign Up"}
                onClick={status.isLoggedIn ? action.logout : action.showLoginPopup}
                style={styles.userButton}
              />
            </Tooltip>
          </Header>
          <Content style={styles.content}>{children}</Content>
          <Footer style={styles.footer}>
            <DataSource />
            <p>
              {`© 2013-${new Date().getFullYear()} `}
              <a target="_new" href="//www.unifiedpatents.com">
                {"Unified Patents, LLC"}
              </a>
              {" All Rights Reserved."}
            </p>
            <div>
              <a target="_blank" rel="noopener noreferrer" href="//www.unifiedpatents.com/term-of-services" style={styles.footerLink}>
                <small>{"Terms of Service"}</small>
              </a>
              <a target="_blank" rel="noopener noreferrer" href="//www.unifiedpatents.com/privacy-policy" style={styles.footerLink}>
                <small>{"Privacy Policy"}</small>
              </a>
              <a target="_blank" rel="noopener noreferrer" href="//www.unifiedpatents.com/dmca" style={styles.footerLink}>
                <small>{"DMCA"}</small>
              </a>
              <a target="_new" rel="nofollow" href="//us7.campaign-archive.com/home/?u=866ac391733e3597058db05fb&id=c51091b53c" style={styles.footerLink}>
                <small>{"Daily Update Email Archive"}</small>
              </a>
              <a target="_new" rel="nofollow" href={zendeskLink} style={styles.footerLink}>
                <small>{"Report Error"}</small>
              </a>
            </div>
          </Footer>
        </Layout>
      </Layout>
    </Layout>)
  );
}

export default withUser(BaseContainer);
